import { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import SweetAlert2 from "react-sweetalert2";
import { CopyToClipboard } from "../../../utils/CommonHelper";
import { Modal } from "../../common/Modal";
import * as actions from "../redux/AgentAction";

export const ShareDialog = ({ selAgentId, selMemberId, fromSide }) => {
  const intl = useIntl();
  const dismissBtnRef = useRef();
  const [swalProps, setSwalProps] = useState({});
  const dispatch = useDispatch();
  const agentState = useSelector(({ agent }) => agent, shallowEqual);
  const modalRef = useRef(null); // Ref for the modal element

  useEffect(() => {
    const modal = document.getElementById("ShareModal");
    modalRef.current = modal; // Store the modal reference

    const handleModalShow = () => {
      if (fromSide === "agent" && selAgentId) {
        const queryParams = {
          action: "shareagentaccount",
          selagentid: selAgentId,
        };
        dispatch(actions.shareAgentDetails(queryParams));
      }

      if (fromSide === "subagent" && selAgentId) {
        const queryParams = {
          action: "sharesubagentaccount",
          selagentid: selAgentId,
        };
        dispatch(actions.shareSubAgentDetails(queryParams));
      }

      if (fromSide === "member" && selMemberId) {
        const queryParams = {
          action: "sharememberaccount",
          selmemberid: selMemberId,
        };
        dispatch(actions.shareMemberDetails(queryParams));
      }
    };

    if (modal) {
      modal.addEventListener("shown.bs.modal", handleModalShow);
    }

    return () => {
      if (modal) {
        modal.removeEventListener("shown.bs.modal", handleModalShow);
      }
    };
  }, [selAgentId, selMemberId, fromSide]);

  return (
    <div style={{ width: "100%", margin: "0 auto" }}>
      <SweetAlert2
        customClass="custom-swal"
        onResolve={() => {
          setSwalProps({});
        }}
        {...swalProps}
      />
      <Modal
        modalId="ShareModal"
        title={intl.formatMessage({ id: "shareDetails" })}
        dismissBtnRef={dismissBtnRef}
      >
        <div className="p-3 custom-border-bottom">
          {fromSide === "agent" || fromSide === "subagent"
            ? agentState?.shareAgentDetails && (
              <div className="d-flex flex-column flex-md-row">
                <div style={{ display: "grid", gridTemplateColumns: "max-content max-content auto", columnGap: "0.5rem" }}>
                  {(agentState.shareAgentDetails.weburl !== "") && (
                    <>
                      <div>{intl.formatMessage({ id: "webUrl" })}</div>
                      <div>:</div>
                      <div>{agentState.shareAgentDetails.weburl}</div>
                    </>
                  )}

                  {agentState.shareAgentDetails.telegramactiveurl !== "" && (
                    <>
                      <div>{intl.formatMessage({ id: "telegramActiveUrl" })}</div>
                      <div>:</div>
                      <div>{agentState.shareAgentDetails.telegramactiveurl}</div>
                    </>
                  )}

                  <div>{intl.formatMessage({ id: "username" })}</div>
                  <div>:</div>
                  <div>{agentState.shareAgentDetails.username}</div>
                  {agentState.shareAgentDetails.password !== "" && (
                    <>
                      <div>{intl.formatMessage({ id: "password" })}</div>
                      <div>:</div>
                      <div>{agentState.shareAgentDetails.password}</div>
                    </>
                  )}
                </div>
                <div className="align-self-end align-self-md-center mt-3 mt-md-0 ms-md-5">
                  <i
                    className="bi bi-copy fs-3"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      CopyToClipboard(
                        `${agentState.shareAgentDetails.weburl !== ""
                          ? `${intl.formatMessage({
                            id: "webUrl",
                          })}: ${agentState.shareAgentDetails.weburl}`
                          : ""
                        }${agentState.shareAgentDetails.telegramactiveurl !== ""
                          ? `\n${intl.formatMessage({
                            id: "telegramActiveUrl",
                          })}: ${agentState.shareAgentDetails.telegramactiveurl}`
                          : ""
                        }\n${intl.formatMessage({ id: "username" })}: ${agentState.shareAgentDetails.username
                        }${agentState.shareAgentDetails.password !== ""
                          ? `\n${intl.formatMessage({
                            id: "password",
                          })}: ${agentState.shareAgentDetails.password}`
                          : ""
                        }`,
                        setSwalProps,
                        intl
                      );
                    }}
                  ></i>
                </div>
              </div>
            )
            : agentState?.shareMemberDetails && (
              <div className="d-flex flex-column flex-md-row">
                <div style={{ display: "grid", gridTemplateColumns: "max-content max-content auto", columnGap: "0.5rem" }}>
                  {agentState.shareMemberDetails.weburl !== "" && (
                    <>
                      <div>{intl.formatMessage({ id: "webUrl" })}</div>
                      <div>:</div>
                      <div>{agentState.shareMemberDetails.weburl}</div>
                    </>
                  )}
                  {agentState.shareMemberDetails.telegramactiveurl !== "" && (
                    <>
                      <div>{intl.formatMessage({ id: "telegramActiveUrl" })}</div>
                      <div>:</div>
                      <div>{agentState.shareMemberDetails.telegramactiveurl}</div>
                    </>
                  )}

                  <div>{intl.formatMessage({ id: "username" })}</div>
                  <div>:</div>
                  <div>{agentState.shareMemberDetails.username}</div>
                  {agentState.shareMemberDetails.password !== "" && (
                    <>
                      <div>{intl.formatMessage({ id: "password" })}</div>
                      <div>:</div>
                      <div>{agentState.shareMemberDetails.password}</div>
                    </>
                  )}
                </div>
                <div className="align-self-end align-self-md-center mt-3 mt-md-0 ms-md-5">
                  <i
                    className="bi bi-copy fs-3"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      CopyToClipboard(
                        `${agentState.shareMemberDetails.weburl !== ""
                          ? `\n${intl.formatMessage({
                            id: "webUrl",
                          })}: ${agentState.shareMemberDetails.weburl}`
                          : ""
                        }${agentState.shareMemberDetails.telegramactiveurl !== ""
                          ? `\n${intl.formatMessage({
                            id: "telegramActiveUrl",
                          })}: ${agentState.shareMemberDetails.telegramactiveurl}`
                          : ""
                        }\n${intl.formatMessage({ id: "username" })}: ${agentState.shareMemberDetails.username
                        }${agentState.shareMemberDetails.password !== ""
                          ? `\n${intl.formatMessage({
                            id: "password",
                          })}: ${agentState.shareMemberDetails.password}`
                          : ""
                        }`,
                        setSwalProps,
                        intl
                      );
                    }}
                  ></i>
                </div>
              </div>
            )}
        </div>
      </Modal>
    </div>
  );
};
